import { createI18n } from 'vue-i18n';

const messages = {
  de: {
    form: {
      introduction: 'Wichtig',
      reportViolation: 'Verstoß melden',
      introductionText: 'Sofern Sie Fragen zum vorstehenden Formular oder zu den anderen vorstehenden Punkten haben, können Sie sich auch gerne per E-Mail über die folgende Mailadresse an uns wenden: dsa{\'@\'}codepiraten.com.',
      introductionTextIllegalContent: 'Ausführliche Informationen zum Meldeprozess für rechtswidrige Inhalte finden Sie hier:',
      introductionTextLink: 'Meldeprozess für rechtswiedrige Inhalte (PDF)',
      dataOfSender: 'Daten zum Absender',
      firstName: 'Vorname',
      firstNameError: 'Vorname ist ein Pflichtfeld',
      lastName: 'Nachname',
      lastNameError: 'Nachname ist ein Pflichtfeld',
      confirmCorrectDataError: 'Bitte bestätigen',
      email: 'E-Mail-Adresse',
      emailRequiredError: 'E-Mail-Adresse ist ein Pflichtfeld',
      emailInvalidError: 'E-Mail ist ungültig',
      reason: 'Grund der Meldung',
      reasonError: 'Grund der Meldung ist ein Pflichtfeld',
      submitIdentityText: 'Ich bestätige, dass für die Prüfung der gemeldeten Rechtsverletzung die Weiterleitung meiner Identität an den Kunden des Hosting-Anbieters unbedingt notwendig ist.',
      isImportantText: 'Es besteht für mich der Verdacht, dass eine Straftat, die eine Gefahr für das Leben oder die Sicherheit einer Person oder von Personen darstellt, begangen wird.',
      send: 'Absenden',
      messageSuccessfulSent: 'Ihre Nachricht wurde erfolgreich verschickt!',
      sendAnotherMessage: 'Weitere Nachricht senden',
      sexualAbuseText: 'Ich bestätige, dass es sich bei den gemeldeten Informationen um Informationen handelt, bei denen davon ausgegangen wird, dass sie eine Straftat im Zusammenhang mit sexuellem Missbrauch oder sexueller Ausbeutung von Kindern, Kinderpornografie, Kontaktaufnahme zu Kindern für sexuelle Zwecke oder Versuch/Anstiftung/Beihilfe zur Begehung der vorgenannten Straftaten betreffen (Straftaten nach den Artikeln 3 bis 7 der Richtlinie 2011/93/EU).',
      confirmCorrectDataText: 'Ich bin in gutem Glauben und davon überzeugt, dass die in der Meldung enthaltenen Angaben und Anführungen richtig und vollständig sind.',
    },
    confirmation: {
      title: 'Vielen Dank für Ihre Meldung!',
      text: 'Ihre Meldung ist bei uns eingegangen und wird bearbeitet.',
      emailHint: 'Sofern Sie eine E-Mail-Adresse angegeben haben, erhalten Sie eine Eingangsbestätigung per E-Mail.',
    },
  },
  en: {
    form: {
      introduction: 'Important',
      reportViolation: 'Report violation',
      introductionText: 'If you have any questions about the above form or the other points above, you are also welcome to contact us by e-mail at the following address: dsa{\'@\'}codepiraten.com.',
      introductionTextIllegalContent: 'Detailed information on the reporting process for illegal content can be found here:',
      introductionTextLink: 'Notification process for illegal content (PDF)',
      dataOfSender: 'Data about the sender',
      firstName: 'First name',
      firstNameError: 'First name is a required field',
      lastName: 'Last name',
      lastNameError: 'Last name is a required field',
      email: 'Email address',
      emailRequiredError: 'Email address is a required field',
      emailInvalidError: 'Email is invalid',
      reason: 'Reason for the message',
      reasonError: 'Reason for the message is a required field',
      submitIdentityText: 'I confirm that it is absolutely necessary to forward my identity to the hosting provider\'s customer in order to check the reported infringement.',
      isImportantText: 'I suspect that a criminal offense is being committed that poses a threat to the life or safety of a person or persons.',
      send: 'Send',
      messageSuccessfulSent: 'Your message has been sent successfully!',
      sendAnotherMessage: 'Send another message',
      sexualAbuseText: 'I confirm that the information reported is information that is believed to relate to a criminal offense involving sexual abuse or sexual exploitation of children, child pornography, contacting children for sexual purposes or attempting/inciting/assisting in the commission of the aforementioned criminal offenses (criminal offenses under Articles 3 to 7 of Directive 2011/93/EU)',
      confirmCorrectDataText: 'I am in good faith and believe that the information and statements contained in the notification are correct and complete.',
    },
    confirmation: {
      title: 'Thank you for your report!',
      text: 'We have received your report and it is being processed.',
      emailHint: 'If you provided an email address, you will receive a confirmation of receipt by email.',
    },
  }
};

export default createI18n({
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  legacy: false,
  messages,
  messageCompiler: false,  // 👈 verhindert Compile-Fehler
});
